import apiLmsConteudo from '../../../services/apiLmsConteudo';

function getFileName(file) {
  const fileNameSplitted = file.name.split('.');

  if (fileNameSplitted.length > 1) {
    fileNameSplitted.pop();
    return fileNameSplitted.join('.');
  }

  return fileNameSplitted[0];
}

export default async function upload(
  file,
  nome = null,
  categoria = null,
  aulaId = null,
  onUploadProgress
) {
  const fileType = file.type.split('/')[0];
  const fileSizeKb = file.size / 1000;

  if (nome === null) {
    nome = getFileName(file);
  }

  if (fileType === 'image' && fileSizeKb > 1024) {
    return Promise.reject(
      new Error('Não são permitidas imagens maiores que 1MB.')
    );
  }

  return new Promise((resolve, reject) => {
    uploadFile(file, aulaId, categoria, onUploadProgress)
      .then(data => {
        const tipo = file.type.split('/')[0];
        const saveAssetData = {
          url: data.url,
          categoria_id: categoria ? categoria.id : null,
          tipo,
          nome
        };
        apiLmsConteudo
          .post('/assets', saveAssetData)
          .then(() => {
            resolve(data);
          })
          .catch(err => reject(err));
      })
      .catch(err => {
        reject(err);
      });
  });
}

function getFileNameUpload(file) {
  try {
    const fileNameSplitted = file.name.split('.');
    const fileName =
      Date.now() + '.' + fileNameSplitted[fileNameSplitted.length - 1];
    return fileName;
  } catch (error) {
    return file.name;
  }
}

async function uploadFile(file, aulaId, categoria, onUploadProgress) {
  const chunkSize = 5 * 1024 * 1024; // 5MB por chunk
  const totalChunks = Math.ceil(file.size / chunkSize);
  let uploadId = null;
  let partNumber = 1;
  let parts = [];
  const fileName = getFileNameUpload(file);

  // Primeiro chunk - inicia o upload
  const firstChunk = await blobToBase64(file.slice(0, chunkSize));
  const formData = new FormData();

  formData.append('chunk', firstChunk);
  formData.append('fileName', fileName);
  formData.append('fileSize', file.size);
  formData.append('isFirstChunk', 'true');
  formData.append('categoria', categoria?.nome);
  formData.append('aulaId', aulaId);

  const firstResponse = await apiLmsConteudo.post('/upload-chunk', formData);

  if (firstResponse.data.url) {
    return firstResponse.data;
  }

  const firstData = firstResponse.data;
  uploadId = firstData.uploadId;
  partNumber = firstData.partNumber;
  parts = JSON.parse(firstData.parts);

  // Chunks intermediários
  for (let i = 1; i < totalChunks - 1; i++) {
    const chunk = await blobToBase64(
      file.slice(i * chunkSize, (i + 1) * chunkSize)
    );
    const form = new FormData();
    form.append('chunk', chunk);
    form.append('fileName', fileName);
    form.append('fileSize', file.size);
    form.append('uploadId', uploadId);
    form.append('partNumber', partNumber);
    form.append('parts', JSON.stringify(parts));
    form.append('categoria', categoria.nome);
    form.append('aulaId', aulaId);

    try {
      const response = await apiLmsConteudo.post('/upload-chunk', form);
      const data = response.data;

      if (data.error) {
        throw new Error(data.error);
      }

      partNumber = data.partNumber;
      parts = JSON.parse(data.parts);

      // Atualiza a barra de progresso
      if (onUploadProgress) {
        onUploadProgress(data.progress);
      }
    } catch (error) {
      console.error('Erro ao enviar chunk:', error);
      throw error;
    }
  }

  // Último chunk
  const lastChunk = await blobToBase64(
    file.slice((totalChunks - 1) * chunkSize)
  );
  const lastFormData = new FormData();
  lastFormData.append('chunk', lastChunk);
  lastFormData.append('fileName', fileName);
  lastFormData.append('fileSize', file.size);
  lastFormData.append('uploadId', uploadId);
  lastFormData.append('partNumber', partNumber);
  lastFormData.append('isLastChunk', 'true');
  lastFormData.append('parts', JSON.stringify(parts));
  lastFormData.append('categoria', categoria.nome);
  lastFormData.append('aulaId', aulaId);

  try {
    const lastResponse = await apiLmsConteudo.post(
      '/upload-chunk',
      lastFormData
    );
    const lastData = lastResponse.data;

    if (lastData.error) {
      throw new Error(lastData.error);
    }

    return lastData;
  } catch (error) {
    console.error('Erro ao enviar último chunk:', error);
    throw error;
  }
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Remove o prefixo "data:application/octet-stream;base64,"
      const base64 = reader.result;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
